import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { validateReduxForm } from 'common/form';
import { validations, TextField } from '@unite-us/app-components';
import { updateServiceCase } from 'actions/Case/Contact/Group';
import { OverlaySpinner } from 'common/spinners';
import ModalEditFormSubmitState from 'common/modal/ModalEditFormSubmitState';
import './stylesheets/detail-view.scss';

const fields = [
  'description',
];

class DetailSummaryForm extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const {
      detailObj,
      initializeForm,
    } = this.props;
    initializeForm({ description: detailObj.description });
  }

  onSubmit(formInputs) {
    const { closeModal, submit } = this.props;
    return submit(formInputs)
      .then(() => {
        closeModal();
      });
  }

  render() {
    const {
      descriptionSubtitle,
      fields: {
        description,
      },
      formId,
      handleSubmit,
      onSubmitStateChange,
      submitting,
    } = this.props;

    return (
      <form id={formId} className="content-with-actions" onSubmit={handleSubmit(this.onSubmit)}>
        <OverlaySpinner show={submitting} text="Submitting Description..." />
        <ModalEditFormSubmitState
          onChange={onSubmitStateChange}
          submitting={submitting}
          submitDisabled={submitting}
        />
        <div className="content-container">
          <TextField
            afterLabelContent={descriptionSubtitle}
            ref={this.props.registerField}
            field={description}
            id="notes"
            label="Description"
            validations={validations.isRequired}
            required
          />
        </div>
      </form>
    );
  }
}

DetailSummaryForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  detailObj: PropTypes.object.isRequired,
  descriptionSubtitle: PropTypes.node,
  fields: PropTypes.object.isRequired,
  formId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  onSubmitStateChange: PropTypes.func.isRequired,
  registerField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

DetailSummaryForm.defaultProps = {
  descriptionSubtitle: null,
};

function mapStateToProps(state, ownProps) {
  const {
    session: {
      groupId,
    },
  } = state;

  return {
    groupId,
    initialValues: {
      description: ownProps.notes,
    },
  };
}

export default validateReduxForm(
  {
    form: 'editDetailField',
    fields,
  },
  mapStateToProps,
  { updateServiceCase },
)(DetailSummaryForm);
